<script type="ts">
    import { useNavigate } from 'svelte-navigator';
    import sessionStore from '../../store/session';
    import toast from '../../services/toast';
    import ButtonRounded from '../../common/ButtonRounded.svelte';
    import type { Profile } from '../../types/session';
    import { onMount } from 'svelte';
    import { getNumbers as GetNumbers } from '../../domain/session/profile.action'
    import Header from '../../components/Header.svelte';
    import Footer from '../../components/Footer.svelte';
    import Icon from '../../components/Icon.svelte';
  import { ICONS } from '../../services/utils';

    const navigate = useNavigate();
    let loading = false
    let errors: Record<string, string> = {}
    let numbers: Array<Profile | any> = $sessionStore.receivers || []
    let profile: Profile | any = $sessionStore.profile || {business: {}}

    const handleNumberSelection = (receiver) => {
        errors = {}
        sessionStore.setReceiver(receiver);
        return null
    }

    const handleContinueClick = () => {
        if (Object.values($sessionStore.receiver).length === 0) {
            errors.review = "please select a number before you proceed."
            toast.error({message: errors.review})
            return;
        }
        navigate("/")
    }

    const handleChangeBusiness = () => {
        navigate("/choose-business")
    }

    onMount(async () => {
        // if (!$sessionStore.receivers || ($sessionStore.receivers && $sessionStore.receivers.length === 0)) {
            await loadNumbers()
        // }
    });

    const loadNumbers = async () => {
        if (!profile.business?.id) {
            toast.error({message: "Please select a business first"});
            return
        }
        loading = true
        try {
            const { receivers } = await GetNumbers(profile.business.id)
            if (receivers) {
                numbers = receivers
                sessionStore.setReceivers(receivers)
            }
        } catch (error) {
            const { message = "Ops! seems error occured!"} = error
            errors.review = message
            toast.error({message})
        } finally {
            loading = false
        }
    }
    
</script>

<Header />
<div class="flex h-full justify-center items-center">
    <div class="w-full">
        <div class="display-flex">
            <div class="flex flex-col w-full">
                
                <div class="relative mx-8 mt-16 mb-8 text-gray-400 text-left">
                    <strong class="text-black text-lg secondary-text-color">
                        Choose a number to continue
                    </strong>
                    <br/>
                    <span class="text-sm flex my-3">
                        <img src={ICONS.logo} alt="logo" width="15px" style="height: 15px" />&nbsp; { profile?.business?.name || "" } 
                        <!-- svelte-ignore a11y-click-events-have-key-events -->
                        <span class="primary-text-color cursor-pointer underline ml-2" on:click={handleChangeBusiness}>
                            { profile?.business?.name ? "Change business" : "Choose business" }
                        </span>
                    </span>

                    <div class="mt-4 w-full">
                        <div class="">
                            {#if numbers.length > 0}
                            <div class="flex flex-col h-1/2 overflow-y-scroll" style="height: 32vh;">
                                <ul class="py-1">
                                    {#each numbers as receiver}
                                        <!-- svelte-ignore a11y-click-events-have-key-events -->
                                        <li 
                                            class="flex justify-between my-3 rounded-md px-4 relative py-2 {receiver.id === ($sessionStore.receiver || {}).id ? 'border-2 selected' : 'border'}" 
                                            on:click={handleNumberSelection(receiver)}
                                        >
                                            <div class="checkbox">
                                                <div class="text-xs text-gray-500">
                                                    { receiver.business_number.country_code } MOBILE NUMBER . 
                                                    { receiver.business_number.label }
                                                </div>
                                                <div class="flex text-gray-900">
                                                    {#if receiver.business_number.country_code === "NG"}
                                                    <img src={ICONS.ng} alt="ng-logo" width="20px" style="height: 20px"  /> 
                                                    {:else if receiver.business_number.country_code === "US"}
                                                    <img src={ICONS.us} alt="us-logo" width="20px" style="height: 20px"  /> 
                                                    {:else}
                                                    <img src={ICONS.logo} alt="pressone-logo" width="20px" style="height: 20px"  /> 
                                                    {/if}
                                                    &nbsp;
                                                    { receiver.business_number.phone_number }
                                                </div>
                                            </div>
                                            <div>
                                                <input 
                                                    type="radio" 
                                                    name="business_selection" 
                                                    checked={$sessionStore.receiver?.business_number?.phone_number === receiver.business_number.phone_number} 
                                                    class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                                                />
                                            </div>
                                        </li>
                                    {/each}
                                </ul>
                            </div>
                            {:else if loading}
                                <div class="flex justify-center items-center h-4/6" style="height: 16rem;">
                                    <Icon icon="loader" />
                                    <i class="animate-pulse">loading record...</i>
                                </div>
                            {:else}
                                <div class="mb-4 text-xs text-center mt-4">
                                    No business number
                                    <p>
                                        Click here to 
                                        <button 
                                            on:click={loadNumbers} 
                                            class="border px-2"
                                            disabled={loading}
                                        >&#8634; refresh</button>
                                    </p>
                                </div>
                            {/if}
                            <ButtonRounded
                                disabled={Object.values($sessionStore.receiver || {}).length === 0}
                                on:click={handleContinueClick}
                                title=""
                                loading={loading}
                                className="call-btn-bg-color h-10 mt-4 w-full flex-inline text-white px-8 text-sm"
                            >
                            Continue
                            </ButtonRounded>
                        </div>
                        {#if errors.review}
                            <small class="text-xs text-red-500">{ errors.review }</small>
                        {/if}
                    </div>
                </div>
            </div>
        </div>

    </div>
</div>
<Footer />
<style>
    .primary-text-color {
        color: var(--primary-text-color)
    }
    .secondary-text-color {
        color: var(--secondary-text-color)
    }
    .selected {
        border-color: var(--primary-bg-color);
        background-color: rgb(from var(--primary-bg-color) r g b / 15%);
        margin: 0px 3px;
    }
    .selected .checkbox:before {
        content: " ";
        position: absolute;
        z-index: -1;
        top: -5px;
        left: -5px;
        right: -5px;
        bottom: -5px;
        border: 3px solid rgb(from var(--primary-bg-color) r g b / 15%);
        border-radius: 0.575rem;
    }
</style>
